export default "__VITE_ASSET__D53BA1Od__"